<!--
  The rail toggle and the mark, in that order, as evo-accounts' app bar has
  them. The control is the same one in both states: `menu` opens the rail, `x`
  closes it. A separate opener with no matching way back is how evo-accounts'
  client bar was wrong before it was fixed there.
-->
<span class="app-bar-lead">
  <button
    type="button"
    class="icon-btn menu-btn"
    data-testid="rail-toggle"
    (click)="sidebarToggle.emit()"
    [attr.aria-expanded]="!isSidebarHidden()"
    [attr.aria-label]="isSidebarHidden() ? 'Open navigation' : 'Close navigation'">
    <ng-icon [name]="isSidebarHidden() ? 'lucideMenu' : 'lucideX'" />
  </button>

  <!--
    `/`, not `/v2`. Stage 1 moved the v2 tree from `path: 'v2'` to `path: ''`
    (cutover.md) and this absolute path was missed, so the wordmark -- the one
    link on the page everybody assumes goes home -- led to a route that no
    longer exists.
  -->
  <app-v2-brand route="/" />
</span>

<span class="spacer"></span>

<span class="clock data" data-testid="utc-clock">{{ utc() }}</span>

<button
  type="button"
  class="icon-btn"
  data-testid="theme-toggle"
  [attr.aria-label]="themeLabel()"
  (click)="theme.toggleTheme()">
  <ng-icon [name]="theme.theme() === 'dark' ? 'lucideSun' : 'lucideMoon'" />
</button>

<!--
  The slot this was holding open is filled.

  Its comment argued the feed lives in flightcompass with no API here
  (data-gaps G11), and that a client would otherwise see a permanently empty
  bell. Both were true of that feed and neither is true of the price-request
  inbox, which has been live on production throughout and is staff-only -- so
  no client sees a bell at all. See G21.

  Gated on a session existing at all: the bell polls an authenticated
  endpoint the moment it mounts (see the component's own comment on why the
  template's internal `@if (isStaff())` cannot be the only guard), and an
  anonymous visitor has no cookie for it to poll with.
-->
@if (user()) {
  <app-v2-notification-bell />
}

<button
  type="button"
  class="icon-btn"
  data-testid="account-button"
  aria-label="Account"
  (click)="accountToggle.emit()">
  <ng-icon name="lucideCircleUser" />
</button>

